import React from "react";

const Error = props => {
  return (
    <div className="error">
      <p>Error Page</p>
    </div>
  );
};

export default Error;
